import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type EarringsIconProps = CreateIconComponentProps;
export const EarringsIcon: React.FC<EarringsIconProps> = ({
  title = 'Earrings',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      d="M8.835 4.124s-.333-1.376-.517-1.695c-.184-.318-1.038-.906-1.894-.412-.856.495-.775 1.529-.591 1.847.184.32 1.21 1.295 1.21 1.295V7.3"
    />
    <circle cx="7" cy="9.3" r="2" stroke="currentColor" strokeWidth="1.7" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      d="M7 17.3v-6M5.22 10.8S4 18.137 4 19.177c0 1.041.6 3.123 3 3.123s3-2.082 3-3.123c0-1.04-1.22-8.377-1.22-8.377M16.273 4.124s.333-1.376.517-1.695c.184-.318 1.038-.906 1.894-.412.856.495.775 1.529.591 1.847-.183.32-1.21 1.295-1.21 1.295V7.3"
    />
    <circle r="2" stroke="currentColor" strokeWidth="1.7" transform="matrix(-1 0 0 1 18.108 9.3)" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      d="M18.108 17.3v-6M19.889 10.8s1.22 7.337 1.22 8.377c0 1.041-.6 3.123-3 3.123s-3-2.082-3-3.123c0-1.04 1.219-8.377 1.219-8.377"
    />
  </CreateIconComponent>
);
